import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { LanguageTranslateService } from "src/app/_services/language-translate.service";
import { SubscriptionUtil } from "src/app/_utilities/subscription";

@Component({
    selector: "app-custella-contracts",
    templateUrl: "./custella-contracts.component.html",
    styleUrls: ["./custella-contracts.component.scss"],
    standalone: false
})
export class CustellaContractsComponent
  extends SubscriptionUtil
  implements OnInit, OnDestroy, OnChanges
{
  @Output() itemSelector = new EventEmitter();
  @Output() closeView = new EventEmitter();
  @Input() customerId: any;

  public searchValue = "";
  translate: any;

  constructor(private languageTranslateService: LanguageTranslateService) {
    super();
    this.push(
      this.languageTranslateService.menuSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
        }
      })
    );
  }

  ngOnChanges(changes: SimpleChanges): void {}

  ngOnInit(): void {}

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  selectItem(val: any) {
    this.itemSelector.emit(val);
  }

  public closeTable() {
    this.closeView.emit(false);
  }

  push(obs: any) {
    super.push(obs);
  }
}
